import {on} from 'delegated-events'

on('submit', '.js-remove-org-form', event => {
  /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
  const iAgree = document.querySelector<HTMLInputElement>('.js-confirm-remove-org-checkbox')!
  const errorMessage = document.querySelector<HTMLElement>('.js-confirm-removal-error')

  if (!iAgree.checked) {
    event.preventDefault()

    iAgree.setAttribute('aria-invalid', 'true')
    iAgree.setAttribute('invalid', 'true')
    iAgree.setAttribute('aria-describedby', 'js-confirm-removal-error')
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    errorMessage!.hidden = false
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    errorMessage!.setAttribute('aria-hidden', 'false')
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    errorMessage!.scrollIntoView({
      behavior: 'smooth',
    })
  }
})

on('click', '.js-confirm-remove-org-checkbox', event => {
  const iAgree = event.target as HTMLInputElement
  const errorMessage = document.querySelector<HTMLElement>('.js-confirm-removal-error')

  if (iAgree.checked) {
    iAgree.removeAttribute('aria-invalid')
    iAgree.removeAttribute('invalid')
    iAgree.removeAttribute('aria-describedby')
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    errorMessage!.hidden = true
    /* eslint-disable-next-line @typescript-eslint/no-non-null-assertion */
    errorMessage!.setAttribute('aria-hidden', 'true')
  }
})
